import { render } from "./CaptureDetails.vue?vue&type=template&id=f4599ade"
import script from "./CaptureDetails.vue?vue&type=script&lang=js"
export * from "./CaptureDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__